import {ContextBranch} from "@/contexts/Branch"
import { useAuth } from "@/hooks/useAuth"
import { api } from "@/services/api"
import { useQuery } from "@tanstack/react-query"
import { ReactElement } from "react"

export type TFilial = {
  ativo: true,
  bairro: string,
  cep: string,
  cnpj: string,
  codcidade: number,
  codigo: string,
  empresa: number,
  endereco: string,
  estado: string,
  id: number,
  idservidorimpressora: string,
  ie: string,
  logo: string,
  nomecidade: string,
  nomefantasia: string,
  numero: string,
  telefone: string
}

export function BranchProvider ({ children }: { children: ReactElement | ReactElement[] }) {
    
    const { token } = useAuth()

    const { data: filial, isLoading } = useQuery({
        queryKey: ['filial', token],
        queryFn: async () => {
            if(token) {
                return await api.get<TFilial>('filial/geral/info')
            } 
            return { data: null }
        },
        select: (data) => data?.data,
        enabled: !!token,
        staleTime: 1000 * 60 * 10,
        refetchInterval: 1000 * 60 * 10,
        cacheTime: 1000 * 60 * 10,
        retry: 2,
        refetchOnWindowFocus: false,
    })

    return (
        <ContextBranch.Provider value={{ filial: filial || null, isLoading }}>
            {children}
        </ContextBranch.Provider>
    )
}